import { useCallback, useRef } from 'react';

import { useGetStructureSummaryDepartmentCount } from '@/api/hco/structureSummary/useGetStructureSummaryCounts';
import useHcoDataScopeStore from '../store/useHcoDataScopeStore';

interface UseHcoDataScopeReturn {
  includeAllDepartments: boolean;
  isToggleDisabled: boolean;
  setIncludeAllDepartments: (checked: boolean) => void;
}

export function useHcoDataScope(hcoBk: string | undefined): UseHcoDataScopeReturn {
  const preference = useHcoDataScopeStore(state => state.preference);
  const setPreference = useHcoDataScopeStore(state => state.setPreference);
  const { department: departmentCount } = useGetStructureSummaryDepartmentCount(hcoBk, preference);

  const hasDepartments = (departmentCount.data ?? 0) > 0;
  const departmentAvailability = useRef({ hcoBk, hasNoDepartments: false });

  if (departmentAvailability.current.hcoBk !== hcoBk) {
    departmentAvailability.current = { hcoBk, hasNoDepartments: false };
  }
  if (departmentCount.isSuccess) {
    departmentAvailability.current.hasNoDepartments = !hasDepartments;
  }

  const hasNoDepartments = departmentAvailability.current.hasNoDepartments;

  return {
    includeAllDepartments: preference && !hasNoDepartments,
    isToggleDisabled: hasNoDepartments,
    setIncludeAllDepartments: useCallback((checked: boolean) => setPreference(checked), [setPreference]),
  };
}
